<template>
  <v-card flat>
    <v-row
      v-for="preg in ad_simple" 
      class="py-1 px-3"
      style="border-bottom: 1px #f3f3f3 solid;"
      align="center"
    >
      <v-col class="py-0 pr-4 text-left">
        <span v-if="preg.question"> {{preg.question}}</span>
        <span v-else> 
          ¿Cuántas licencias de {{preg.base_q}} se ejercieron en {{period_ies.year}} en la institución?
        </span>
      </v-col>
      <div class="float-right mx-3">
        <v-text-field
          class="mt-0"
          type="number"
          :readonly="!is_ies || !editable"
          v-model="data_ad[preg.key_name]"
          label="respuesta"
        ></v-text-field>
      </div>
    </v-row>

    <v-row
      v-for="preg in ad_complex" 
      class="py-2 px-3"
      style="border-bottom: 1px #f3f3f3 solid;"
      align="center"
    >
      <v-col class="py-0 pr-4 text-left" cols="8">
        {{preg.question}}
      </v-col>
      <v-row class="float-right mx-3" cols="4" >
        <v-text-field
          v-for="opc in preg.responses"
          class="mt-0 ml-2 width-field right-input"
          type="number"
          :readonly="!is_ies || !editable"
          :suffix="preg.name!='quejas_genero' ? '%' : null"
          v-model="data_ad[opc.key_name]"
          :label="opc.label"
        ></v-text-field>
      </v-row>
    </v-row>
    <v-card-actions v-if="is_ies && editable">
      <v-spacer></v-spacer>
      <v-btn color="success" @click="updateExtraInfo"> 
        Guardar
      </v-btn>
      
    </v-card-actions>
  </v-card>
</template>


<script>

import router from "@/router.js";
import { mapState } from "vuex";

export default {
  name: 'AditionalData',
  props:{
    data_ad:{
      type: Object,
      required: true,
    },
    period_ies:{
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      show_help: true,
      ad_simple : [
        {"key_name": "lactancia", "question":"¿Cuántas salas de lactancia existen en la institución?"},
        {"key_name": "guarderias", "question":"¿Cuántas guarderías tiene su institución?"},
        {"key_name": "licencias_paternidad", "base_q": "paternidad" },
        {"key_name": "licencias_maternidad", "base_q": "maternidad" },
      ],
      ad_complex : [
        {
          "name": "pob_lgbtiq",
          "question": "¿Cuál es el porcentaje de población LGBTIQ de la institución?",
          "responses": [
            {"key_name":"pob_lgbtiq_est", "label":"Estudiantes"},
            {"key_name":"pob_lgbtiq_acad", "label":"Académicos"},
            {"key_name":"pob_lgbtiq_admin", "label":"Administrativos"},
          ]
        },
        {
          "name": "quejas_genero",
          "question": "¿Cuántas quejas por violencia de género se presentaron en el año?",
          "responses": [
            {"key_name":"quejas_genero_hom", "label":"Hombres"},
            {"key_name":"quejas_genero_muj", "label":"Mujeres"},
            {"key_name":"quejas_genero_lgbtiq", "label":"LGBTIQ"},
          ]
        },
        {
          "name": "prev_violencia",
          "question": "¿Cuál es la prevalencia de violencia de género en su institución?",
          "responses": [
            {"key_name":"prev_violencia_muj", "label":"Hombres"},
            {"key_name":"prev_violencia_hom", "label":"Mujeres"},
            {"key_name":"prev_violencia_lgbtiq", "label":"LGBTIQ"},
          ]
        },
      ],
      ad_pob_lgbtiq: ["_est", "_acad", "_admin"],
      ad_por_sexo: ["quejas_genero", "prev_violencia"],
      ad_pobs: ["_hom", "_muj", "_lgbtiq"],
    }
  },
  methods:{
    updateExtraInfo() {
      //console.log(this.data_ad)

      var base_data = Object.keys(this.data_ad)
        //.filter(key => this.mean_info.some(x=>x.short_key == key))
        .reduce((obj, key) => {
          if (this.data_ad[key])
            obj[key] = this.data_ad[key]
          /*if (this.mean_info.some(x=>x.short_key==key)) 
            obj[key] = this.ies_year_data.register_referance[key];  */

          //obj[key] = 
          return obj;
        }, {});

      //console.log(base_data)

      
      this.$store
        .dispatch('UPDATE_PERIOD_IES_BASE', {data:base_data, 
          period_ies_id:this.period_ies.ies_period_id,
          snack_text: "Información Adicional actualizada"})
        .then((data) => {
          //console.log(data)
        })
        .catch(error =>
          console.log(error)
        );
      
    },

  },
  computed:{
    ...mapState({
      is_ies: state => state.is_ies,
      editable: state => state.ies_year_data.register_referance.status.can_ies_change,
    }),
  },
  created(){
  }
}
</script>


<style scoped>

</style>